var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"pages-remote-background\">\n<div class=\"page-remote-locale-chooser\">\n<locale-chooser-small></locale-chooser-small>\n</div>\n<div class=\"pages-remote-background-band\">\n<div class=\"logo-black\"></div>\n</div>\n<div class=\"pages-remote-content\">\n<div class=\"pages-remote-content-headings\">\n<h3>{{ 'STATIC_PAGES.PASSWORD_UPDATED.GREAT' | translate }}</h3>\n<p ng-bind-html=\"'STATIC_PAGES.PASSWORD_UPDATED.PASSWORD_UPDATED_CLICK_HERE' | translate | html\"></p>\n</div>\n</div>\n</div>\n";
var id1="password_reset_success.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/templates/password_reset_success.html
// module id = 435
// module chunks = 0